import "./Breadcrumb.css";
import React, { useState, useEffect } from 'react';
import CreateTaskModal from "../CreateBookingModal";
import { useTranslation } from 'react-i18next';
import UserService from "../../services/user.service";
import { Menu, MenuList, MenuItem, IconButton, ListItemText, ListItemIcon, Divider } from '@mui/material';

const Breadcrumb = ({ onViewChange, selected, api, onFlyproFilterChange, onFilterDate, filterDate, auth }) => {
  const handleButtonClick = (view) => {
    onViewChange(view);
  };
  const { t, i18n } = useTranslation(['dashboard']);
  const userRoles = auth?.roles;
  const [flypros, setFlys] = useState([]);
  const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
  const filterMenuOpen = Boolean(filterMenuAnchor);

  const handleFilterMenuClick = (event) => {
    setFilterMenuAnchor(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setFilterMenuAnchor(null);
  };
  const isPrivileged = userRoles?.some(role => role.name === "ROLE_ADMIN" || role.name === "ROLE_HOTEL_MANAGER");

  const fetchFlys = async () => {
    try {
      const response = await UserService.indexByRole({
        status: 'ACTIVE',
        ...( !isPrivileged && { flypro_manager_id: auth?.user?.id } ),
      }, 'ROLE_FLYPRO', api);

      const sorted = response.sort((a, b) =>
        a.firstname.localeCompare(b.firstname, 'en', { sensitivity: 'base' })
      );

      setFlys(sorted);

    } catch (error) {
    }
  };

  useEffect(() => {

    fetchFlys();

  }, []);
  return (
    <div className="bloc-search background-breadcrumb">
      <div className="container">
        <div className="desktop-hidden">
          <IconButton onClick={handleFilterMenuClick}>
            <img src='assets/images/filter.png' alt='actions' height={20} />
          </IconButton>
        </div>
        <div className="search" style={{ gap: '5px' }}>
          <div className="breadcrumb-navigation">
            <button
              className={`breadcrumb-map-button ${selected === "list" ? "active" : ""}`}
              onClick={() => handleButtonClick("list")}
            >
              <div className={`icon ${selected === "list" ? "active-icon" : ""}`} />
              <span className="breadcrumb-label">{t('list')}</span>
            </button>

            <button
              className={`breadcrumb-list-button ${selected === "map" ? "active" : ""}`}
              onClick={() => handleButtonClick("map")}
            >
              <div className={`icon ${selected === "map" ? "active-icon" : ""}`} />
              <span className="breadcrumb-label-list">{t('map')}</span>
            </button>
          </div>
        </div>
        <div className="desktop-hidden">
          <Menu anchorEl={filterMenuAnchor}
            open={filterMenuOpen}
            onClose={handleFilterMenuClose}
          >
            <MenuList
              style={{ padding: 0 }}
            >
              <MenuItem onClick={handleFilterMenuClose} disableRipple>
                <ListItemIcon>
                  <img src='assets/images/filter.png' alt='actions' height={20} />

                </ListItemIcon>
                <ListItemText>Filters</ListItemText>
              </MenuItem>
              <Divider></Divider>
              <div className="search" style={{ gap: '5px' }}>

                <div className="text-search">
                  <input
                    type="date"
                    name="search"
                    value={filterDate || ""}
                    onChange={(e) => {
                      onFilterDate(e.target.value);
                    }}
                    className="form-text"
                  />
                </div>
                <div>
                  <select
                    name="flypro"
                    onChange={(e) => onFlyproFilterChange(e.target.value)}
                    style={{ padding: '10px' }}
                  >
                    <option value="">{t('search.flyproAll')}</option>
                    {flypros.map((fly) => (
                      <option key={fly.id} value={fly.id}>
                        {fly.firstname}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </MenuList>
          </Menu>
        </div>
        <div className="search" style={{ gap: '5px' }}>
          <div className="bloc-filtre" style={{ overflowX: 'auto', overflowY: 'hidden', padding: '0 10px', scrollbarWidth: 'none' }}>
            <div className="text-search">
              <input
                type="date"
                name="search"
                value={filterDate || ""}
                onChange={(e) => {
                  onFilterDate(e.target.value);
                }}
                className="form-text"
              />
            </div>
            <div>
              <select
                name="flypro"
                onChange={(e) => onFlyproFilterChange(e.target.value)}
                style={{ padding: '10px' }}
              >
                <option value="">{t('search.flyproAll')}</option>
                {flypros.map((fly) => (
                  <option key={fly.id} value={fly.id}>
                    {fly.firstname}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        {selected === "map" && <CreateTaskModal api={api} />}
      </div>
    </div>
  );
};

export default Breadcrumb;
